import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// styles
import styles from './ciam.module.scss';

// components
import { Title } from '../Title/Title';

// utils
import { getLanguage, useScript } from './use-script';
import { TitleFormats } from '../Title/title.types';
import { useIsoLang } from 'scenes/MetaData';
import { ciamScriptSelector, ciamKeySelector } from 'utils/selectors/globalsSelectors';
import { useSectionId } from 'utils/hooks/use-section-id';

export interface ResetProps {
  titleInAnchor: boolean;
  contentIndex: number;
  border?: string;
  title?: string;
  subtitle?: string;
  anchor?: string;
}

export function Reset({
  border,
  title,
  anchor,
  subtitle,
  contentIndex,
  titleInAnchor,
}: Readonly<ResetProps>) {
  const sectionId = useSectionId(title ?? '', anchor ?? '', titleInAnchor, contentIndex);
  const locale = useIsoLang();
  const scriptUrl = useSelector(ciamScriptSelector);
  const apiKey = useSelector(ciamKeySelector);
  const borderClass = border === 'disable-border' ? styles.disableBorder : '';

  const { isLoaded } = useScript({
    scriptUrl,
    apiKey,
    locale,
  });

  useEffect(() => {
    if (isLoaded) {
      const langParam = getLanguage(locale);
      if (window.gigya) {
        window.gigya.accounts.showScreenSet({
          screenSet: 'Geberit-RegistrationLogin',
          startScreen: 'gigya-reset-password-screen',
          containerID: 'GIGYAContainer',
          lang: String(langParam).toLowerCase(),
        });
      }
    }
  }, [isLoaded, locale]);

  return (
    <div className="grid-container">
      <div className={`${styles.ciamWrapper} ${borderClass}`} id={sectionId}>
        <Title
          title={title}
          subtitle={subtitle}
          Format={TitleFormats.h3}
          titlePreviewId="#st_title"
          subtitlePreviewId="#st_subtitle"
        />
        <div id="GIGYAContainer" />
      </div>
    </div>
  );
}
